import { createFileRoute } from "@tanstack/react-router";
import ThankYouReview from "@/pages/ThankYouReview";

export const Route = createFileRoute("/thank-you/review")({
  component: ThankYouReview,
});
